export const styleToggle = (predicate: boolean, trueStyle: string, falseStyle?: string) =>
  predicate ? trueStyle : (falseStyle ?? "");
